import radarDaNuvemLogo from '@/public/logo-radar-da-nuvem.png';
import { brandColors, neutralColor } from '@/config/theme/colors';

/** Deep purple gradient used by the app sidebar atmosphere. */
export const SIDEBAR_GRADIENT =
  'linear-gradient(180deg, hsl(270, 60%, 12%) 0%, hsl(270, 55%, 18%) 50%, hsl(270, 50%, 22%) 100%)';

/** Auth brand panel background — aligned with login / sidebar family. */
export const AUTH_PANEL_BACKGROUND = brandColors.primary.darker;

/**
 * Single canvas color for authenticated app pages and the auth form column.
 * Keep page roots on this token — do not invent per-page backgrounds.
 */
export const APP_PAGE_BACKGROUND = neutralColor[100];

/** Auth form column uses the same canvas as the app shell. */
export const AUTH_FORM_BACKGROUND = APP_PAGE_BACKGROUND;

/**
 * Soft wash reserved for rare marketing moments. Prefer flat APP_PAGE_BACKGROUND
 * for product pages so the shell stays uniform.
 */
export const APP_CONTENT_WASH = `linear-gradient(180deg, ${brandColors.primary.highlight} 0%, ${neutralColor[100]} 220px)`;

/** Page / auth form titles — same ink as login headlines. */
export const APP_TITLE_COLOR = neutralColor[950];

/** Page / auth form subtitles. */
export const APP_SUBTITLE_COLOR = neutralColor[700];

/** Compact Radar logo used in auth brand panel and sidebar. */
export const RADAR_LOGO = radarDaNuvemLogo;

export const brandSurface = {
  sidebarGradient: SIDEBAR_GRADIENT,
  authPanelBackground: AUTH_PANEL_BACKGROUND,
  authFormBackground: AUTH_FORM_BACKGROUND,
  appContentWash: APP_CONTENT_WASH,
  appPageBackground: APP_PAGE_BACKGROUND,
  appTitleColor: APP_TITLE_COLOR,
  appSubtitleColor: APP_SUBTITLE_COLOR,
  logo: RADAR_LOGO,
} as const;
